import { collectionSetupAxiosInstance } from '../../axios/collectionSetupAxios';

const getSmeManualPayment = async (requestData: any) => {
  const params = {
    filters: requestData?.params?.filters,
    search: requestData?.params?.search,
    sortField: requestData?.params?.sortField,
    sortOrder: requestData?.params?.sortOrder,
    currentPage: requestData?.params?.pagination.current,
    pageSize: requestData?.params?.pagination.pageSize,
  };

  const url = `/redCash/api/v1.0/payment/manual`;
  const res = await collectionSetupAxiosInstance.get(url, { params });
  return res.data;
};

const smeManualPaymentService = {
  getSmeManualPayment,
};

export default smeManualPaymentService;
